import { render, staticRenderFns } from "./ediJobList.vue?vue&type=template&id=128895a9&scoped=true"
import script from "./ediJobList.vue?vue&type=script&lang=js"
export * from "./ediJobList.vue?vue&type=script&lang=js"
import style0 from "./ediJobList.vue?vue&type=style&index=0&id=128895a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128895a9",
  null
  
)

export default component.exports